import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { LoginApi } from "../../api/request/users";
import LoadableButton from "../../components/buttons/LoadableButton"
import { useSelector } from 'react-redux';
import { setUserDetails, setloggedIn } from "../../store/Slices/userSlice";
import Lock from "../../assets/auth/Lock";
import Message from "../../assets/auth/Message";
import { removeCookies } from "../../services/Cookies";
import { setCookies } from "../../services/Cookies.js";
import { useDispatch } from 'react-redux';

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { broker } = useSelector(state => state.broker);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    removeCookies('token');
    const { email, password } = formData;

    if (!email || !password) {
      toast.error("Email or password can not be empty");  
      return;
    } 
    try {
      setIsLoading(true);
      const { data } = await LoginApi({ ...formData, platformName: "admin"});
      if (data?.success) {
        toast.success(data?.message);
        localStorage.setItem("verifyWithOpt", JSON.stringify(data?.data?.verifyWithOpt));
        if (data?.data?.verifyWithOpt) {
          localStorage.setItem("userId", data?.data?.userId);
          navigate("/otp");
        } else {
          setCookies('token', data?.data?.access_token);
          dispatch(setloggedIn(true));
          let user = data?.data;
          delete user?.access_token;
          dispatch(setUserDetails(user));
          localStorage.clear('userId');
          navigate("/dashboard");
        }
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong");
      }
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9]' style={{backgroundImage:"url('/assets/images/authbg.png')",backgroundSize:"cover",backgroundPosition:"center",backgroundRepeat:"no-repeat"}}>
        <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
          <div className="flex justify-center mb-8">
            <img src='/assets/logo/logo.png' alt='logo' className='h-10 w-48 object-contain' draggable="false"/>
          </div>
          <div className="w-full">
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className="w-full text-sm py-1">
                <p className="text-[#585F70] font-semibold ">Email</p>
                <div className="relative">
                  <Form.Item type="email" name="emailId">
                    <Input
                      placeholder="Enter your email-id"
                      className="border rounded-lg w-full ps-4 py-2"
                      prefix={
                        <Message />
                      }
                      onChange={handleChange}
                      name="email"
                      value={formData.email}
                      defaultValue={formData.email}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="w-full text-sm font-normal py-1 mt-3">
                <p className="text-[#585F70] font-semibold">Password</p>
                <div div className="relative">
                  <img
                    src="../assets/images/lock.svg"
                    alt=""
                    className="absolute top-[15%] left-5"
                  />
                  <Form.Item name="password">
                    <Input.Password
                      placeholder="Enter your password"
                      className="border rounded-lg w-full ps-4 py-2"
                      prefix={
                        <Lock />
                      }
                      name="password"
                      onChange={handleChange}
                      value={formData.password}
                      defaultValue={formData.password}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="flex justify-end w-full text-sm font-normal">
                <Link
                  to="/forget_password"
                  className="font-semibold text-xs primary cursor-pointer"
                >
                  Forgot Password?
                </Link>
              </div>
              <div className="mt-5">
                <LoadableButton className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2' type='submit' lable='Login' isLoading={isLoading} loadingLable='Loging in...' />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default Login;
